import { FC } from 'react'

import { useCheckReadOnlyAccess } from 'clickNgo/hooks/access'

import { ContactList } from '../contactList/ContactList'

import { IContactListTabProps } from './models'

export const ContactListTab: FC<IContactListTabProps> = ({
  appSource,
  flexWidth,
  isEditActionDisabled,
  partnerId,
  onAfterFetch,
  onBeforeFetch,
  onCatchError,
  onEditContact,
  onSelectProfile,
  useSource,
  columns,
  ignoredFields,
  isPartner360Page,
  metrics,
}) => {
  const isReadOnly = useCheckReadOnlyAccess()
  const { source } = useSource({ partnerId, onAfterFetch, onBeforeFetch, onCatchError })

  if (!source) {
    return null
  }

  return (
    <ContactList
      appSource={appSource}
      partnerId={partnerId}
      isEditActionDisabled={isEditActionDisabled || isPartner360Page}
      columns={columns}
      source={source}
      flexWidth={flexWidth}
      metrics={metrics}
      ignoredFields={ignoredFields}
      onSelectProfile={onSelectProfile}
      onEditContact={onEditContact}
      hideAddNewButtons={isReadOnly || isPartner360Page}
    />
  )
}
